<ng-container *ngIf="view; then viewMode; else editMode"></ng-container>

<ng-template #viewMode>
  <div class="flex-row no-wrap align-center gap-5">
    <ng-container *ngIf="externalLink === null || externalLink.length === 0; else withLink">
      <button class="ep-btn ep-btn-quarternary btn-addLink" (click)="toggleEdit()" [disabled]="disabled">
        <app-svg-icon src="./assets/icons/ep-link.svg"></app-svg-icon>
      </button>
      <span class="flex-stretch ep-text-regular-16 text-wrap" [class.disabled]="disabled">{{
        'module.userProfile.generalConfiguration.emptyLink' | translate
      }}</span>
    </ng-container>

    <ng-template #withLink>
      <a
        appReusableTooltip
        [href]="externalLink"
        [tooltip]="externalLink"
        [class.disabled]="disabled"
        target="_blank"
        class="ep-action-link ep-text-ellipsis ep-external"
      >
        {{ externalLink }}
      </a>
      <a class="btn-clearLink" (click)="clearLink()" [class.disabled]="disabled"><app-svg-icon src="./assets/icons/ep-delete-bin.svg"></app-svg-icon></a>
    </ng-template>
  </div>
</ng-template>

<ng-template #editMode>
  <div class="flex-column align-start">
    <div class="flex-row align-center ep-gap-4" [ngClass]="{ 'adjust-height': externalLinkFormControl.errors }">
      <app-ep-input-form-field
        #linkInput
        appAutofocus
        class="flex-stretch no-padding pad-r4"
        [formControlName]="externalLinkFormControl"
        [isValid]="externalLinkFormControl.errors === null || externalLinkFormControl.errors?.length === 0"
        (inputBlur)="linkChanged($event)"
      >
      </app-ep-input-form-field>
      <button class="ep-btn ep-btn-quarternary btn-cancelLink pad-r4" (click)="cancelEdit()">
        <app-svg-icon src="./assets/icons/ep-delete.svg"></app-svg-icon>
      </button>
    </div>
    <span *ngIf="externalLinkFormControl.errors" class="error-message flex-stretch ep-text-regular-16 text-wrap">
      {{ 'module.userProfile.generalConfiguration.invalidLink' | translate }}
    </span>
  </div>
</ng-template>
